import React from "react";
import "./index.scss"
import NeuroScholaProject from "../assets/NeuroScholaProject.png"
import NeuroCollectorProject from "../assets/NeuroCollectorProject.png"
import sjclfx from "../assets/sjclfx.png"
import { SlideContentOne, SlideContentTwo, SlideContentThree, SlideContentFour, SlideContentFive } from "./SlideContent";
import InsightEpilepsy from "../assets/InsightEpilepsy.png"
import dxsjk from "../assets/dxsjk.png";
import DetailOne from "../components/projectDetail/detailOne";
import DetailTwo from "../components/projectDetail/detailTwo";
import arrowLeft from "../assets/arrow-left.png"
import arrowRight from "../assets/arrow-right.png"
import DetailThree from "../components/projectDetail/detailThree";
import DetailFour from "../components/projectDetail/detailFour"
import DetailFive from "../components/projectDetail/detailFive";
import $ from "jquery";
import guangyun from "../assets/guangyun.png";
import Radio from "../components/Radio";
import download from "../assets/download.png";
import banner2 from "../assets/home-page/banner2.png"
import slideContentOneImg from "../assets/slideContentOneImg.png"
import brainRedLineImg from "../assets/brain-red-line.png"
import dataAnalysis from "../assets/data-analysis.png"
import insight1Img from "../assets/insight1.png"
import colorBrainImg from "../assets/color-brain.png"

class ProjectPipe extends React.Component {

    state = {
        activeTab: 1,
        activeSlide: 1,
    }

    scrollNext(max, key) {
        let activeSlide = this.state[key]
        if (activeSlide == max) return;
        if (this.props.location.state) {
            this.props.location.state.activeSlide = activeSlide + 1
        }
        this.setState({ [key]: activeSlide + 1 })
    }

    scrollPrev(min, key) {
        let activeSlide = this.state[key]
        if (activeSlide == min) return;
        if (this.props.location.state) {
            this.props.location.state.activeSlide = activeSlide - 1
        }
        this.setState({ [key]: activeSlide - 1 })
    }

    componentDidMount() {
        if (this.props.location.state.goToBar) {
            document.getElementsByClassName("project-part-2")[0].scrollIntoView()
        }
        this.setState({ activeSlide: this.props.location.state?.activeSlide || 1 })
    }

    pdfs = [
        {
            url: "../brochurePDF/NeuroScholar.pdf",
            name: "NeuroScholar",
            type: "平台"
        },
        {
            url: "../brochurePDF/NeuroCollector.pdf",
            name: "NeuroCollector",
            type: "系统"
        },
        {
            url: "../brochurePDF/NeuroSignal.pdf",
            name: "NeuroSignal",
            type: "平台"
        },
        {
            url: "../brochurePDF/InsightEpilepsy.pdf",
            name: "InsightEpilepsy",
            type: "系统"
        }
    ]
    
    analaysisList = [
        {
            info: <div className="slide-content">
                <SlideContentOne />
                <div>
                    <img src={slideContentOneImg} style={{width: "12.5333rem", height: "8.4333rem", marginTop: "2.2rem"}} />
                    <img className="img-bg" src={guangyun} style={{ right: "-1rem", bottom: "0" }}/>
                </div>     
            </div>,
            detail: <DetailOne />
        },
        {
            info: <div className="slide-content">
                <SlideContentTwo />
                <div>
                    <img src={brainRedLineImg} style={{width: "15.3333rem", height: "12.2rem", marginTop: "-1.9333rem"}}/>
                    <img className="img-bg" src={guangyun} style={{ right: "-1rem", bottom: "0.9333rem" }}/>
                </div>
            </div>,
            detail: <DetailTwo />
        },
        {
            info: <div className="slide-content">
                <SlideContentThree />
                <div>
                    <img src={dataAnalysis} style={{width: "13.3rem", height: "13.2333rem", marginTop: "-2.2rem"}}/>  
                    <img className="img-bg" src={guangyun} style={{ right: "0.5333rem", bottom: "0.6667rem" }}/>
                </div>   
            </div>,
            detail: <DetailThree />
        }
    ]
    
    InsightEpilepsyList = [
        {
            info: <div className="slide-content">
                <SlideContentFour />
                <div>
                    <img src={insight1Img} style={{width: "9rem", height: "11.9333rem", marginTop: "-1rem"}}/>    
                    <img className="img-bg" src={guangyun} style={{ right: "1.0667rem", bottom: "0.5333rem" }}/> 
                </div>
            </div>,
            detail: <DetailFour />
        },
        {
            info: <div className="slide-content">
                <SlideContentFive />
                <div>
                    <img src={colorBrainImg} style={{width: "12rem", height: "11rem"}}/>     
                    <img className="img-bg" src={guangyun} style={{ right: "-0.5rem", bottom: "0rem" }}/> 
                </div>
            </div>,
            detail: <DetailFive />
        }
        
    ]
    
    contentList = [ {list: [...this.analaysisList, ...this.InsightEpilepsyList], index: "activeSlide"} ]
    
    footerBarList = [["NeuroScholar", "NeuroCollector", "数据处理分析服务"], []]
    
    changeBg(e, src, active) {
        if (active) return;
        const img = $(e.target)
        img.attr("src", src)
        img.parent().addClass("white-bg")
    }

    initBg(e, src, active) {
        if (active) return;
        const img = $(e.target)
        img.attr("src", src)
        img.parent().removeClass("white-bg")
    }

    setCurrentSlide(key, value) {
        $(".img-container").removeClass("white-bg")
        if (this.props.location.state) {
            this.props.location.state.activeSlide = value
        }
        this.setState({ [key]: value })
    }

    calcLeft() {
        const curSlide = $(".slide-container")[this.state.activeSlide - 1]
        if (curSlide) {
            const clientRect = curSlide.getBoundingClientRect(),
            fontSize = $("html").css("font-size").replace("px", "") * 1
            return (clientRect.left + (clientRect.width / 2)) + "px" 
        } else {
            return "-100%"
        }
        
    }

    componentDidUpdate() {
        if (this.props.location.state.activeSlide !== this.state.activeSlide) {
            this.setState({ activeSlide: this.props.location.state.activeSlide })
            document.getElementsByClassName("project-part-2")[0].scrollIntoView()
        }
    }

    render() {
        const {list, index} = this.contentList[this.state.activeTab - 1]
        return <div className="project-pipe">
            <div className="project-part-1">
                <img src={banner2} />
                <div className="project-title">
                    <h2>系列产品</h2>
                    <p>在脑健康与脑医学领域，慧脑云持续进行着探索，积极实现相关产品快速走向实际应用。</p>
                </div>
                <div className="project-part-1-info">
                    <h3>聚焦于个体化的脑健康监测与脑疾病诊疗</h3>
                    <p>个体化的脑健康监测与临床上脑重大疾病的精准诊疗，是前沿脑科学研究成果走向实际应用的关键方</p>
                    <p>向，慧脑云现有系列产品聚焦于两大方向——多模态脑影像个体化分析和癫痫致痫灶无创精准定位。</p>
                </div>
            </div>
            <div className="project-part-2">
                <div className="tab-bar">
                    <div className="tab tab-1">
                        <div className="Chinese-title">慧脑云系列产品</div>
                        <div className="English-title">
                            <div>PRODUCT</div>
                            <div>INTRODUCTION</div>
                        </div>
                    </div>
                    <div className="radios">
                        <label>产品方向</label>
                        <Radio isSelect={this.state.activeSlide <= 3} onClick={()=>this.setState({ activeSlide: 1 })}><span className="label">多模态脑影像个体化分析</span></Radio>
                        <Radio isSelect={this.state.activeSlide > 3} onClick={()=>this.setState({ activeSlide: 4 })}><span className="label">癫痫致痫灶无创精准定位</span></Radio>
                    </div>
                    <div className="tab-content">
                        <div className="tab-scroll">
                            <div 
                                className={`${this.state.activeSlide == 1 ? "active-slide slide-container" : "slide-container"}`} 
                                onClick={()=>this.setCurrentSlide("activeSlide", 1)}
                            >
                                <div className="img-container" style={{ background: "transparent"}}>
                                    <img 
                                        src={NeuroScholaProject} 
                                        className="img"
                                    />
                                </div>
                                <div className="project-name">
                                    <p>多模态脑影像</p>
                                    <p>数据管理计算分析平台</p>
                                    <p>NeuroScholar™</p>
                                </div>
                            </div>
                            <div 
                                className={`${this.state.activeSlide == 2 ? "active-slide slide-container" : "slide-container"}`} 
                                onClick={()=>this.setCurrentSlide("activeSlide", 2)}
                            >
                                <div className="img-container" style={{ background: "transparent"}}>
                                    <img 
                                        src={NeuroCollectorProject}  
                                        className="img"
                                    />
                                </div>
                                <div className="project-name">
                                    <p>多模态脑影像</p>
                                    <p>数据质控与管理系统</p>
                                    <p>NeuroCollector™</p>
                                </div>
                            </div>
                            
                            <div 
                                className={`${this.state.activeSlide == 3 ? "active-slide slide-container" : "slide-container"}`} 
                                onClick={()=>this.setCurrentSlide("activeSlide", 3)}
                            >
                                <div className="img-container" style={{ background: "transparent"}}>
                                    <img 
                                        src={sjclfx} 
                                        className="img"
                                    />
                                </div>
                                <div className="project-name">
                                    <p>脑电图/脑磁图</p>
                                    <p>数据管理计算分析平台</p>
                                    <p>NeuroSignal™</p>
                                </div>
                            </div>
                            <div 
                                className={`${this.state.activeSlide == 4 ? "active-slide slide-container" : "slide-container"}`} 
                                onClick={()=>this.setCurrentSlide("activeSlide", 4)}
                            >
                                <div className="img-container" style={{ background: "transparent"}}>
                                    <img 
                                        src={InsightEpilepsy} 
                                        className="img"
                                    />
                                </div>
                                <div className="project-name">
                                    <p>癫痫致痫灶</p>
                                    <p>精准定位系统</p>
                                    <p>InsightEpilepsy™</p>
                                </div>
                            </div>
                            <div 
                                className={`${this.state.activeSlide == 5 ? "active-slide slide-container" : "slide-container"}`} 
                                onClick={()=>this.setCurrentSlide("activeSlide", 5)}
                            >
                                <div className="img-container" style={{ background: "transparent"}}>
                                    <img 
                                        src={dxsjk} 
                                        className="img"
                                    />
                                </div>
                                <div className="project-name">
                                    <p>临床癫痫多模态</p>
                                    <p>数据库平台</p>
                                    <p>EpilepsyData™</p>
                                </div>
                            </div>
                            <div className="arrow-left" onClick={()=>this.scrollPrev(1, "activeSlide")}><img src={arrowLeft}/></div>
                            <div className="arrow-right" onClick={()=>this.scrollNext(5, "activeSlide")}><img src={arrowRight} /></div>
                        </div>
                    </div>
                </div>
                <div className="arrow" id="arrow" style={{ left: this.calcLeft()}}></div>
                {list[this.state[index] - 1].info}
                
            </div>
            <div className="project-part-3">
                <div className="container">
                    {list[this.state[index] - 1].detail}
                </div>
            </div>
            {
                this.pdfs[this.state.activeSlide - 1]
                    ?
                <div className="download-pdf">
                    <a href={this.pdfs[this.state.activeSlide - 1].url} target="_blank">
                        <img src={download} className="download-icon"/>
                        点击下载{this.pdfs[this.state.activeSlide - 1].name}<sup>TM</sup>{this.pdfs[this.state.activeSlide - 1].type}详细产品介绍
                    </a>
                </div>
                    :
                null
            }
            {/* <div className="footer-bar">
                {this.footerBarList[this.state.activeTab - 1].map(item => {
                    return <div key={item}>{item}</div>
                })}
            </div> */}
        </div>
    }
}

export default ProjectPipe;